export const roleId = {
    authenticated: 1,
    public: 2,
    admin: 3,
    accountant: 4,
    manager: 5,
    director: 6,
    operatingDirector: 7,
    cashier: 8,
};

export const role = [
    { label: 'Админ', value: roleId.admin, access: roleId.admin },
    { label: 'Территориальный директор', value: roleId.director },
    { label: 'Бухгалтер', value: roleId.accountant },
    { label: 'Управляющий', value: roleId.manager },
    { label: 'Операционный директор', value: roleId.operatingDirector, access: roleId.admin },
    { label: 'Кассир', value: roleId.cashier },
]